// Ход по набору. Ни одна точка не подписана темой: заголовок темы над задачей
// убивает эффект перемешивания.
//
// С 11 сентября 2026 точки кликабельны, и это не украшение навигации. До этого
// вернуться к уже закрытой задаче было нельзя ничем: набор шёл вперёд и только
// вперёд, а полоса сверху показывала, что задача решена, и не давала посмотреть,
// ЧЕМ она кончилась. Закрытая открывается записью (`today.review`), незакрытая —
// как обычно, на решение. Подписи темы это по-прежнему не раскрывает: в
// доступном имени только номер и состояние.
//
// Область нажатия — кнопка вокруг черты, а не сама черта: 22 × 5 пикселей не
// попадает пальцем, и на телефоне ряд из двадцати пяти черт был бы ловушкой.

import type { Assignment } from "../api";

export function Dots({
  assignments,
  activeTwinItemKeys,
  currentItemKey,
  onPick,
}: {
  assignments: Assignment[];
  /** Незаконченные близнецы не считаются назначениями, но остаются доступны. */
  activeTwinItemKeys?: string[];
  currentItemKey?: string;
  /** Нажатие на задачу набора. Без него точки остаются немыми — так их
      показывает диагностика, где возвращаться назад нечему. */
  onPick?: (itemKey: string) => void;
}) {
  return (
    <div className="dots" aria-label="ход по набору">
      {assignments.map((a, i) => {
        const current = a.itemKey === currentItemKey;
        // «Здесь» отмечается высотой, а не цветом: у закрытой задачи цвет уже
        // занят зелёным, и в пересмотре ряд иначе не говорит, где ты стоишь.
        const cls = [
          "dot",
          a.done ? "dot--done" : current ? "dot--current" : "",
          current ? "dot--here" : "",
        ]
          .filter(Boolean)
          .join(" ");
        const label = `задача ${i + 1}${a.done ? ", решена" : ""}${current ? ", открыта" : ""}`;
        if (onPick === undefined) return <span key={a.itemKey} className={cls} />;
        return (
          <button
            key={a.itemKey}
            className="dot-hit"
            aria-label={label}
            aria-current={current ? "true" : undefined}
            title={label}
            onClick={() => onPick(a.itemKey)}
          >
            <span className={cls} />
          </button>
        );
      })}
      {onPick === undefined
        ? null
        : activeTwinItemKeys?.map((itemKey, i) => {
            const current = itemKey === currentItemKey;
            const label = `похожая задача ${i + 1}${
              current ? ", открыта" : ", не решена"
            }`;
            return (
              <button
                key={itemKey}
                className="dot-hit"
                aria-label={label}
                aria-current={current ? "true" : undefined}
                title={label}
                onClick={() => onPick(itemKey)}
              >
                <span className={`dot${current ? " dot--current dot--here" : ""}`} />
              </button>
            );
          })}
    </div>
  );
}
